"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface FaqItem {
  question: string;
  answer: string;
}

export function FAQSection({ faqItems }: { faqItems: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="border-t border-[var(--color-border)]" aria-labelledby="faq-heading">
      <div className="container py-10 md:py-12">
        <div className="mx-auto max-w-2xl">
          <p className="eyebrow mx-auto">
            FAQ
          </p>
          <h2 id="faq-heading" className="mt-2 text-center font-[family-name:var(--font-display)] text-2xl font-semibold tracking-[-0.015em] text-[var(--color-text)] sm:text-3xl text-balance">
            Frequently asked questions
          </h2>
          <div className="mt-6 space-y-2">
            {faqItems.map((item, i) => (
              <div
                key={i}
                className="rounded-[var(--radius-lg)] border border-[var(--color-border)] bg-[var(--color-surface)] shadow-[var(--shadow-xs)] transition-colors data-[open]:border-[var(--color-accent)]"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="flex w-full items-center justify-between px-4 py-3 text-left"
                  aria-expanded={openIndex === i}
                >
                  <span className="font-medium text-[var(--color-text)]">
                    {item.question}
                  </span>
                  <ChevronDown
                    className={cn(
                      "h-4 w-4 text-[var(--color-text-muted)] transition-transform duration-200",
                      openIndex === i && "rotate-180",
                    )}
                  />
                </button>
                {openIndex === i && (
                  <div className="px-4 pb-3">
                    <p className="text-sm text-[var(--color-text-muted)]">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
